import { SxProps, Theme } from '@mui/material';
import { TEXT_LIGHT_GRAY } from '../../../styles/GlobalStyles';

export const studentProgressCountStyles = {
  container: (theme: Theme) =>
    ({
      display: 'inline-flex',
      alignItems: 'center',
      gap: 0,
      cursor: 'default',
    }) as SxProps<Theme>,

  icon: (_theme: Theme) =>
    ({
      width: '18px',
      height: '18px',
      display: 'block',
    }) as SxProps<Theme>,

  text: (theme: Theme) =>
    ({
      fontSize: theme.typography.body2.fontSize,
      color: TEXT_LIGHT_GRAY,
      fontWeight: 400,
    }) as SxProps<Theme>,
};

export default studentProgressCountStyles;
